import { Form, Input, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  useCreateInput,
  useInputById,
  useUnits,
  useUpdateInput,
} from "../../api/input";
import { setuid } from "process";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { useCreateUser } from "../../api/auth";
import { RegularExpression } from "../../util";
// import { useCreateUser } from '../../api/auth';

type CreateUserModalProps = {
  open: boolean;
  selectedId?: string;
  hideModal: () => void;
};

const CreateUserModal: React.FC<CreateUserModalProps> = ({
  open,
  selectedId,
  hideModal,
}) => {
  const { user } = useAuth() as AuthContextValue;
  const ownerRoles = ["WEB_SHEGAFRE_ADMIN"];
  const agroDealerRoles = [
    "WEB_AGRO_DEALER_OPERATION",
    "WEB_AGRO_DEALER_ADMIN",
    "MOB_AGRO_DEALER_STORE",
  ];
  const bankRoles = ["WEB_BANK_OPERATION", "WEB_BANK_ADMIN"];
  const insuranceRoles = ["INSURANCE_ADMIN", "INSURANCE_USER"];
  const offTakerRoles = ["WEB_OFF_TAKER_OPERATION", "WEB_OFF_TAKER_ADMIN"];
  const shegaFreRoles = [
    "WEB_SHEGAFRE_OPERATION",
    "MOB_VALUE_CHAIN_EXECUTES",
    "MOB_WAREHOUSE_PERSON",
    "MOB_SELLS_PERSON",
    "MOB_AGRONOMY_PERSON",
  ];

  const [fullName, setFullName] = useState<string | undefined>();
  const [userName, setUserName] = useState<string | undefined>();
  const [email, setEmail] = useState<string | undefined>();
  const [phone, setPhone] = useState<string | undefined>();
  const [bankAccount, setBankAccount] = useState<string | undefined>();
  const [role, setRole] = useState<
    | "WEB_SHEGAFRE_ADMIN"
    | "WEB_AGRO_DEALER_OPERATION"
    | "MOB_AGRO_DEALER_STORE"
    | "WEB_BANK_OPERATION"
    | "INSURANCE_ADMIN"
    | "INSURANCE_USER"
    | "INSURANCE_USER"
    | "WEB_OFF_TAKER_OPERATION"
    | "WEB_SHEGAFRE_OPERATION"
    | "WEB_INSURANCE_ADMIN"
    | "WEB_BANK_ADMIN"
    | "WEB_AGRO_DEALER_ADMIN"
    | "WEB_SHOP_ADMIN"
    | "MOB_VALUE_CHAIN_EXECUTES"
    | "MOB_WAREHOUSE_PERSON"
    | "MOB_SELLS_PERSON"
    | "MOB_AGRONOMY_PERSON"
    | undefined
  >(user?.roleName === "ROLE_SUPER_ADMIN" ? "WEB_SHEGAFRE_ADMIN" : undefined);

  const [hasFormError, setHasFormError] = useState(true);
  const [nameError, setNameError] = useState<string>();
  const [userNameError, setUserNameError] = useState<string>();
  const [emailError, setEmailError] = useState<string>();
  const [phoneNoError, setPhoneNoError] = useState<string>();
  const [roleError, setRoleError] = useState<string>();

  const [options, setOptions] = useState<string[]>([]);

  const { mutateAsync: createUser, isSuccess, isPending } = useCreateUser();

  useEffect(() => {
    if (user) {
      switch (user.roleName) {
        case "ROLE_SUPER_ADMIN":
          setOptions(ownerRoles);
          break;
        case "ROLE_MPC_ADMIN":
          setOptions(agroDealerRoles);
          break;
        case "ROLE_MFI_ADMIN":
          setOptions(bankRoles);
          break;
        case "INSURANCE_ADMIN":
          setOptions(insuranceRoles);
          break;
        case "ROLE_OFF_TAKER_ADMIN":
          setOptions(offTakerRoles);
          break;
        case "ROLE_KFT_SUPER_ADMIN":
          setOptions(shegaFreRoles);
          break;
        default:
          break;
      }
    }
  }, [user]);

  useEffect(() => {
    let isNameError = true;
    let isUserNameError = true;
    let isEmailError = true;
    let isPhoneError = true;
    let isRoleError = true;

    if (fullName) {
      isNameError = !RegularExpression.name.test(fullName);
      if (isNameError) {
        isNameError = true;
        setNameError("Invalid name");
      } else {
        isNameError = false;
        setNameError(undefined);
      }
    }

    if (userName) {
      isUserNameError = !RegularExpression.userName.test(userName);
      if (isUserNameError) {
        isUserNameError = true;
        setUserNameError("Invalid user name");
      } else {
        isUserNameError = false;
        setNameError(undefined);
      }
    }

    if (email) {
      isEmailError = !RegularExpression.email.test(email);
      if (isEmailError) {
        isEmailError = true;
        setEmailError("Invalid email");
      } else {
        isEmailError = false;
        setEmailError(undefined);
      }
    }

    if (phone) {
      isPhoneError = !RegularExpression.phoneNo.test(phone);
      if (isPhoneError) {
        isPhoneError = true;
        setPhoneNoError("Invalid phone number");
      } else {
        isPhoneError = false;
        setPhoneNoError(undefined);
      }
    }

    if (role) {
      if (role) {
        isRoleError = false;
        setRoleError(undefined);
      } else {
        isRoleError = true;
        setRoleError("Invalid role");
      }
    }



    setHasFormError(
      isNameError ||
        isUserNameError ||
        isEmailError ||
        isPhoneError ||
        isRoleError,
    );
  }, [fullName, userName, email, phone, role, bankAccount]);

  const onsubmit = async () => {
    try {
      if (
        user &&
        user.mfiId &&
        fullName &&
        role &&
        userName &&
        email &&
        phone &&
        !hasFormError
      ) {
        const result = await createUser({
          orgId: user.mfiId,
          fullName: fullName,
          role:
            user.roleName === "ROLE_SUPER_ADMIN" ? "WEB_SHEGAFRE_ADMIN" : role,
          username: userName,
          email,
          phoneNo: phone,
          bankAccount:bankAccount ? bankAccount : 'N/A',
        });

        if (
          result &&
          result.data &&
          result.data.data &&
          result.data.data.id > 0
        ) {
          message.success("User created successfully.");
          hideModal()
        } else {
          message.error("Operation failed.");
        }
      }
    } catch (err: any) {
      message.error("Operation failed.");
    } finally {
      hideModal();
    }
  };

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 27.43,
            color: "black",
          }}
        >
          Create User
        </div>
      }
      open={open}
      centered
      onOk={onsubmit}
      okButtonProps={{
        disabled: hasFormError,
      }}
      onCancel={hideModal}
      closable
    >
      <div
        style={{
          fontFamily: "Poppins",
          display: "flex",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <Select
          disabled={user?.roleName === "ROLE_SUPER_ADMIN"}
          value={role}
          placeholder="Select role"
          style={{ width: "100%" }}
          onChange={(val: any) => setRole(val)}
          options={options.map((category: string) => {
            return { label: category, value: category };
          })}
        />
        <Input
          placeholder="Insert full name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
        {nameError && <div className="text-red-400">{nameError}</div>}
        <Input
          placeholder="Insert user name"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
        />
        {userNameError && <div className="text-red-400">{userNameError}</div>}
        <Input
          placeholder="Insert email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {emailError && <div className="text-red-400">{emailError}</div>}
        <Input
          placeholder="Insert phone number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        {phoneNoError && <div className="text-red-400">{phoneNoError}</div>}
        <Input
          placeholder="Insert bank account"
          value={bankAccount}
          onChange={(e) => setBankAccount(e.target.value)}
        />
      
      </div>
    </Modal>
  );
};

export default CreateUserModal;
